import styled from 'styled-components';

import { breakpoints, colors, fontFamily, functions } from '../../ui/variables';

export const InstitutionSummaryStyle = styled.main`
  margin-top: 12px;
  width: 100%;

  @media (min-width: ${breakpoints.hd.width}px) {
    display: flex;
  }

  .institution-summary-content,
  .institution-summary-exam-count {
    background-color: ${colors.mostlyWhite};
    border-radius: 12px;
    padding: 30px;
  }

  .institution-summary-content {
    display: flex;
    margin-bottom: 32px;
    position: relative;

    @media (min-width: ${breakpoints.hd.width}px) {
      margin-bottom: 0;
      margin-right: 16px;
      flex-basis: calc(65% - 16px);
    }

    .edit-headquarter-button {
      color: ${colors.softBlue};
      font-size: 14px;
      line-height: 18px;
      padding-left: 28px;
      position: absolute;
      right: 16px;
      top: 16px;

      @media (min-width: ${breakpoints.hd.width}px) {
        right: 32px;
        top: 24px;
      }

      .icon {
        display: block;
        left: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;

        svg {
          display: block;
          fill: ${colors.softBlue};
          height: auto;
          width: 100%;
        }
      }
    }

    .institution-avatar-wrapper {
      .institution-avatar {
        background-color: ${colors.white};
        border-radius: 50%;
        border: solid 1px ${colors.veryLightGrayishBlue};
        max-height: 60px;
        max-width: 60px;
        min-height: 60px;
        min-width: 60px;
        overflow: hidden;

        @media (min-width: ${breakpoints.uxga.width}px) {
          max-height: 120px;
          max-width: 120px;
          min-height: 120px;
          min-width: 120px;
        }

        &.text-avatar {
          ${fontFamily.sourceSansPro.bold};
          align-items: center;
          color: ${colors.softBlue};
          display: flex;
          font-size: 28px;
          justify-content: center;
          line-height: 1;

          @media (min-width: ${breakpoints.uxga.width}px) {
            font-size: 56px;
          }
        }

        .institution-image {
          display: block;
          height: auto;
          max-height: 100%;
          max-width: 100%;
          width: auto;
        }
      }
    }

    .institution-information-content {
      max-width: calc(100% - 60px);
      min-width: calc(100% - 60px);
      padding-left: 16px;

      @media (min-width: ${breakpoints.uxga.width}px) {
        flex-basis: calc(100% - 60px);
        max-width: auto;
        min-width: auto;
      }

      .institution-name-registration-wrapper {
        margin-bottom: 8px;

        .institution-name {
          ${fontFamily.sourceSansPro.bold};
          color: ${colors.veryDarkGrayishBlue};
          display: inline-block;
          font-size: 24px;
          line-height: 30px;
          margin-right: 16px;
        }

        .institution-registration {
          ${fontFamily.sourceSansPro.regular}
          color: ${colors.grayishBlue};
          font-size: 14px;
          line-height: 18px;
          white-space: nowrap;
        }
      }

      .institution-address {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.veryDarkGrayishBlue};
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 32px;
        padding-left: 24px;
        position: relative;

        .icon {
          display: block;
          left: 0;
          position: absolute;
          top: 4px;
          width: 16px;

          svg {
            display: block;
            height: auto;
            width: 100%;
          }
        }
      }

      .institution-count-list {
        width: 100%;

        @media (min-width: ${breakpoints.uxga.width}px) {
          display: flex;
        }

        .count-item {
          ${fontFamily.sourceSansPro.regular};
          align-items: center;
          color: ${colors.veryDarkGrayishBlue};
          display: flex;
          font-size: 14px;
          line-height: 18px;
          margin-bottom: 8px;
          min-height: 32px;
          padding-left: 40px;
          position: relative;

          @media (min-width: ${breakpoints.uxga.width}px) {
            flex-basis: 33.33%;
            margin-bottom: 0;
            padding-right: 8px;
          }

          &:last-child {
            margin-bottom: 0;

            @media (min-width: ${breakpoints.uxga.width}px) {
              padding-right: 0;
            }
          }

          .icon {
            align-items: center;
            background-color: ${functions.rgba(colors.softBlue, 0.25)};
            border-radius: 8px;
            display: flex;
            height: 32px;
            justify-content: center;
            left: 0;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 32px;

            svg {
              display: block;
              fill: ${colors.softBlue};
              height: auto;
              width: 20px;
            }
          }
        }
      }
    }
  }

  .institution-summary-exam-count {
    @media (min-width: ${breakpoints.hd.width}px) {
      flex-basis: calc(35% - 16px);
      margin-left: 16px;
    }

    .time-course-control {
      display: flex;
      flex-wrap: nowrap;
      margin-bottom: 12px;
      width: 100%;

      .time-course-button {
        ${fontFamily.sourceSansPro.regular};
        color: ${colors.veryDarkGrayishBlue};
        display: block;
        flex-basis: 35%;
        font-size: 14px;
        line-height: 18px;
        opacity: 0.25;
        transition: opacity 600ms;

        &:first-child {
          text-align: left;
        }

        &:last-child {
          flex-basis: 30%;
          text-align: right;
        }

        &.active {
          opacity: 1;
        }
      }
    }

    .summary-exam-count-information {
      ${fontFamily.sourceSansPro.bold};
      color: ${functions.rgba(colors.veryDarkGrayishBlue, 0.25)};
      font-size: 24px;
      line-height: 30px;
      margin-bottom: 12px;
      padding-right: 52px;
      position: relative;

      .exam-count {
        ${fontFamily.sourceSansPro.bold};
        color: ${colors.veryDarkGrayishBlue};
        font-size: 52px;
        line-height: 65px;
      }

      .exam-count-label {
        ${fontFamily.sourceSansPro.bold};
        bottom: 8px;
        color: ${colors.veryDarkGrayishBlue};
        font-size: 14px;
        line-height: 18px;
        position: absolute;
        right: 0;
        width: fit-content;
      }
    }

    .exam-count-progress-bar-container {
      background-color: ${functions.rgba(colors.softBlue, 0.25)};
      border-radius: 8px;
      height: 16px;
      overflow: hidden;
      width: 100%;

      .exam-count-progress-value {
        background-color: ${colors.softBlue};
        height: 100%;
        transition: width 300ms;
      }
    }
  }
`;
